module.exports = __webpack_public_path__ + "img/expressage.a880499e.png";